var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgExplainerBackgroundIconsShort({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 318,
    height: 400,
    viewBox: "0 0 318 400",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M290.656 367.054L285.029 372.679L304.202 391.853H285.024V399.808H317.784V367.047H309.828V386.226L290.656 367.054Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M317.779 331.962L312.153 326.335L292.98 345.508V326.33H285.024V359.09H317.785V351.134H298.607L317.779 331.962Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M285.03 312.741L290.656 318.367L309.829 299.194V318.373H317.785V285.612H285.024V293.568H304.202L285.03 312.741Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M277.061 372.679L271.434 367.053L252.262 386.226V367.047H244.306V399.808H277.067V391.852H257.888L277.061 372.679Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M249.937 326.336L244.312 331.962L263.484 351.135H244.306V359.091H277.066V326.33H269.11V345.509L249.937 326.336Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M277.061 291.244L271.434 285.617L252.262 304.791V285.612H244.306V318.373H277.067V310.416H257.888L277.061 291.244Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M209.221 367.054L203.595 372.679L222.767 391.853H203.589V399.808H236.349V367.047H228.393V386.226L209.221 367.054Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M209.221 326.336L203.595 331.962L222.767 351.135H203.589V359.091H236.349V326.33H228.393V345.509L209.221 326.336Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M209.221 285.618L203.595 291.244L222.767 310.417H203.589V318.373H236.349V285.612H228.393V304.79L209.221 285.618Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M127.785 367.054L122.158 372.679L141.331 391.853H122.153V399.808H154.913V367.047H146.957V386.226L127.785 367.054Z",
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M122.159 353.459L127.785 359.085L146.957 339.912V359.091H154.913V326.33H122.153V334.287H141.331L122.159 353.459Z",
    fill: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M149.282 318.366L154.907 312.741L135.735 293.568H154.913V285.612H122.153V318.373H130.109V299.194L149.282 318.366Z",
    fill: "black"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M81.4422 394.176L87.0678 399.802L106.24 380.63V399.808H114.197V367.047H81.436V375.004H100.615L81.4422 394.176Z",
    fill: "black"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M87.0678 326.336L81.4414 331.962L100.615 351.135H81.436V359.091H114.197V326.33H106.24V345.509L87.0678 326.336Z",
    fill: "black"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M108.565 318.366L114.19 312.741L95.018 293.568H114.197V285.612H81.436V318.373H89.3924V299.194L108.565 318.366Z",
    fill: "black"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M46.3496 367.054L40.7231 372.679L59.8963 391.853H40.7178V399.808H73.4783V367.047H65.5219V386.226L46.3496 367.054Z",
    fill: "black"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M46.3496 326.336L40.7231 331.962L59.8963 351.135H40.7178V359.091H73.4783V326.33H65.5219V345.509L46.3496 326.336Z",
    fill: "black"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M67.8465 318.366L73.4729 312.741L54.2998 293.568H73.4783V285.612H40.7178V318.373H48.6741V299.194L67.8465 318.366Z",
    fill: "black"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7608 391.851L13.5815 391.851L32.7539 372.679L27.1274 367.053L7.9551 386.226L7.9551 367.047L-0.000488281 367.047L-0.000489713 399.808L32.7608 399.808L32.7608 391.851Z",
    fill: "#FFDF03"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8041 326.33V345.508L5.63179 326.336L0.00537382 331.962L19.1785 351.135H0V359.091H32.7605V326.33H24.8041Z",
    fill: "black"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M0 285.612V318.373H32.7605V310.416H13.582L32.7543 291.244L27.1295 285.617L7.95559 304.791V285.612H0Z",
    fill: "black"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M168.502 367.054L162.877 372.679L182.049 391.853H162.871V399.808H195.631V367.047H187.675V386.226L168.502 367.054Z",
    fill: "black"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M162.877 353.459L168.502 359.085L187.675 339.912V359.091H195.631V326.33H162.871V334.287H182.049L162.877 353.459Z",
    fill: "black"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M168.502 285.618L162.877 291.244L182.049 310.417H162.871V318.373H195.631V285.612H187.675V304.79L168.502 285.618Z",
    fill: "black"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M285.03 272.023L290.656 277.65L309.829 258.477V277.655H317.785V244.895H285.024V252.851H304.202L285.03 272.023Z",
    fill: "black"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M277.061 250.527L271.434 244.9L252.262 264.073V244.895H244.306V277.655H277.067V269.699H257.888L277.061 250.527Z",
    fill: "black"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M209.221 244.901L203.595 250.526L222.767 269.699H203.589V277.656H236.349V244.895H228.393V264.073L209.221 244.901Z",
    fill: "black"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M127.785 244.901L122.158 250.526L141.331 269.699H122.153V277.656H154.913V244.895H146.957V264.073L127.785 244.901Z",
    fill: "black"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M108.565 277.649L114.19 272.023L95.018 252.85H114.197V244.894H81.436V277.655H89.3924V258.477L108.565 277.649Z",
    fill: "black"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M40.7239 272.023L46.3496 277.65L65.5227 258.477V277.655H73.479V244.895H40.7178V252.851H59.8963L40.7239 272.023Z",
    fill: "black"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M0 244.895V277.655H7.95636V258.477L27.1295 277.649L32.7551 272.023L13.5828 252.851H32.7605V244.895H0Z",
    fill: "black"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M168.502 244.901L162.877 250.526L182.049 269.699H162.871V277.656H195.631V244.895H187.675V264.073L168.502 244.901Z",
    fill: "black"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M317.779 209.809L312.153 204.182L292.98 223.355V204.177H285.024V236.938H317.785V228.981H298.607L317.779 209.809Z",
    fill: "black"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M271.434 236.931L277.061 231.306L257.888 212.133H277.066V204.176H244.306V236.938H252.262V217.759L271.434 236.931Z",
    fill: "black"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M236.343 209.809L230.718 204.182L211.545 223.355V204.177H203.589V236.938H236.349V228.981H217.171L236.343 209.809Z",
    fill: "black"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M149.282 236.931L154.907 231.306L135.735 212.133H154.913V204.176H122.153V236.938H130.109V217.759L149.282 236.931Z",
    fill: "black"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M81.4422 231.306L87.0678 236.932L106.24 217.759V236.938H114.197V204.177H81.436V212.133H100.615L81.4422 231.306Z",
    fill: "black"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M40.7239 231.306L46.3496 236.932L65.5227 217.759V236.938H73.479V204.177H40.7178V212.133H59.8963L40.7239 231.306Z",
    fill: "black"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M0 204.176V236.938H7.95636V217.758L27.1295 236.931L32.7551 231.306L13.5828 212.133H32.7605V204.176H0Z",
    fill: "black"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M168.502 204.183L162.877 209.809L182.049 228.982H162.871V236.938H195.631V204.177H187.675V223.355L168.502 204.183Z",
    fill: "black"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M285.03 190.588L290.656 196.214L309.829 177.041V196.22H317.785V163.459H285.024V171.416H304.202L285.03 190.588Z",
    fill: "black"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M277.061 169.091L271.434 163.465L252.262 182.637V163.459H244.306V196.219H277.067V188.263H257.888L277.061 169.091Z",
    fill: "black"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M209.221 163.465L203.595 169.091L222.767 188.264H203.589V196.22H236.349V163.459H228.393V182.638L209.221 163.465Z",
    fill: "black"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M149.282 196.214L154.907 190.587L135.735 171.415H154.913V163.458H122.153V196.22H130.109V177.041L149.282 196.214Z",
    fill: "black"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M108.565 196.214L114.19 190.587L95.018 171.415H114.197V163.458H81.436V196.22H89.3924V177.041L108.565 196.214Z",
    fill: "black"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M40.7239 190.588L46.3496 196.214L65.5227 177.041V196.22H73.479V163.459H40.7178V171.416H59.8963L40.7239 190.588Z",
    fill: "black"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M0 163.459V196.219H7.95636V177.041L27.1295 196.213L32.7551 190.587L13.5828 171.415H32.7605V163.459H0Z",
    fill: "black"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M195.625 169.091L189.999 163.465L170.827 182.637V163.459H162.871V196.219H195.631V188.263H176.453L195.625 169.091Z",
    fill: "black"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M290.656 122.748L285.029 128.373L304.202 147.546H285.024V155.502H317.784V122.741H309.828V141.92L290.656 122.748Z",
    fill: "black"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M271.434 155.496L277.061 149.87L257.888 130.698H277.066V122.741H244.306V155.502H252.262V136.323L271.434 155.496Z",
    fill: "black"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M230.718 155.496L236.344 149.87L217.171 130.698H236.349V122.741H203.589V155.502H211.545V136.323L230.718 155.496Z",
    fill: "black"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M149.282 155.496L154.907 149.87L135.735 130.698H154.913V122.741H122.153V155.502H130.109V136.323L149.282 155.496Z",
    fill: "black"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M81.4422 149.87L87.0678 155.497L106.24 136.323V155.502H114.197V122.741H81.436V130.698H100.615L81.4422 149.87Z",
    fill: "black"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M67.8465 155.496L73.4729 149.87L54.2998 130.698H73.4783V122.741H40.7178V155.502H48.6741V136.323L67.8465 155.496Z",
    fill: "black"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M0 122.741V155.502H32.7605V147.545H13.582L32.7543 128.373L27.1295 122.747L7.95559 141.919V122.741H0Z",
    fill: "black"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M168.502 122.748L162.877 128.373L182.049 147.546H162.871V155.502H195.631V122.741H187.675V141.92L168.502 122.748Z",
    fill: "black"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0.588638V33.3491H7.95636V14.1699L27.1295 33.3422L32.7551 27.7173L13.5828 8.545H32.7605V0.588638H0Z",
    fill: "black"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M67.8465 33.342L73.4729 27.7164L54.2998 8.54402H73.4783V0.587662H40.7178V33.3481H48.6741V14.1697L67.8465 33.342Z",
    fill: "black"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M87.0678 0.59478L81.4414 6.22042L100.615 25.3928H81.436V33.3491H114.197V0.588638H106.24V19.7671L87.0678 0.59478Z",
    fill: "black"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M149.282 33.342L154.907 27.7164L135.735 8.54402H154.913V0.587662H122.153V33.3481H130.109V14.1697L149.282 33.342Z",
    fill: "black"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M162.877 27.7173L168.502 33.343L187.675 14.1706V33.3491H195.631V0.588638H162.871V8.545H182.049L162.877 27.7173Z",
    fill: "black"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M209.221 0.59478L203.595 6.22042L222.767 25.3928H203.589V33.3491H236.349V0.588638H228.393V19.7671L209.221 0.59478Z",
    fill: "black"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M244.312 27.7173L249.937 33.343L269.11 14.1706V33.3491H277.066V0.588638H244.306V8.545H263.484L244.312 27.7173Z",
    fill: "black"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M312.153 33.342L317.779 27.7164L298.606 8.54402H317.784V0.587662H285.024V33.3481H292.98V14.1697L312.153 33.342Z",
    fill: "black"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M0 41.3059V49.2623H19.1785L0.00614154 68.4354L5.63179 74.0603L24.8049 54.8879V74.0664H32.7605V41.3059H0Z",
    fill: "black"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M40.7239 68.4346L46.3496 74.0603L65.5227 54.8879V74.0664H73.479V41.3059H40.7178V49.2623H59.8963L40.7239 68.4346Z",
    fill: "black"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M114.19 46.9377L108.565 41.3113L89.3924 60.4844V41.3059H81.436V74.0664H114.197V66.11H95.018L114.19 46.9377Z",
    fill: "black"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M122.159 68.4346L127.785 74.0603L146.957 54.8879V74.0664H154.913V41.3059H122.153V49.2623H141.331L122.159 68.4346Z",
    fill: "black"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M195.625 46.9377L189.999 41.3113L170.827 60.4844V41.3059H162.871V74.0664H195.631V66.11H176.453L195.625 46.9377Z",
    fill: "black"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M203.595 68.4346L209.221 74.0603L228.393 54.8879V74.0664H236.349V41.3059H203.589V49.2623H222.767L203.595 68.4346Z",
    fill: "black"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M271.434 74.0603L277.061 68.4346L257.888 49.2623H277.066V41.3059H244.306V74.0664H252.262V54.8879L271.434 74.0603Z",
    fill: "black"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M285.03 68.4346L290.656 74.0603L309.829 54.8879V74.0664H317.784V41.3059H285.024V49.2623H304.202L285.03 68.4346Z",
    fill: "black"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M0 82.0232V89.9803H19.1785L0.00614154 109.153L5.63179 114.778L24.8049 95.606V114.784H32.7605V82.0232H0Z",
    fill: "black"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M67.8465 114.778L73.4729 109.152L54.2998 89.9801H73.4783V82.0237H40.7178V114.784H48.6741V95.6057L67.8465 114.778Z",
    fill: "black"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M87.0678 82.0298L81.4414 87.6555L100.615 106.828H81.436V114.784H114.197V82.0237H106.24V101.202L87.0678 82.0298Z",
    fill: "black"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M149.282 114.778L154.907 109.152L135.735 89.9801H154.913V82.0237H122.153V114.784H130.109V95.6057L149.282 114.778Z",
    fill: "black"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M189.999 114.778L195.625 109.152L176.453 89.9801H195.631V82.0237H162.871V114.784H170.827V95.6057L189.999 114.778Z",
    fill: "black"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M209.221 82.0298L203.595 87.6555L222.767 106.828H203.589V114.784H236.349V82.0237H228.393V101.202L209.221 82.0298Z",
    fill: "black"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M249.937 82.0298L244.312 87.6555L263.484 106.828H244.306V114.784H277.066V82.0237H269.11V101.202L249.937 82.0298Z",
    fill: "black"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M312.153 114.778L317.779 109.152L298.606 89.9801H317.784V82.0237H285.024V114.784H292.98V95.6057L312.153 114.778Z",
    fill: "black"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExplainerBackgroundIconsShort);
export default __webpack_public_path__ + "static/media/explainer-background-icons-short.b59abc1864a46ce570c883f6673fa844.svg";
export { ForwardRef as ReactComponent };